import React from 'react';
import '../UploadForm.css';
import SvgIcon from '../common/SvgIcon';
import FileIcon from '../../assets/icons/file_icon3.svg';

function DropAreaLower({
  isDragging,
  onClick,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  fileInputRef,
  onFilesChange,
  disabled = false,
}) {
  return (
    <div className={`drop-resume-container-lower ${disabled ? 'disabled' : ''}`} onClick={disabled ? undefined : onClick} aria-disabled={disabled}>
      <div
        className={`upload-area-container lower ${isDragging ? 'dragging' : ''} ${disabled ? 'disabled' : ''}`}
        onDragEnter={disabled ? undefined : onDragEnter}
        onDragLeave={disabled ? undefined : onDragLeave}
        onDragOver={disabled ? undefined : onDragOver}
        onDrop={disabled ? undefined : onDrop}
        aria-disabled={disabled}
      >
        <SvgIcon
          src={FileIcon}
          color="#666"
          hoverColor="#6e41c1"
          size="39px"
          className="file-icon lower"
        />
        <div className="upload-area-container-text lower">
          <p style={{ cursor: 'pointer' }}>
            <label style={{ cursor: 'pointer', fontSize: '1.1em' }}>
              {' '}
              Drop resume(s) or{' '}
              <span
                style={{
                  alignSelf: 'center',
                  marginBottom: '0',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: '#6e41c1',
                }}
              >
                upload here
              </span>
            </label>
          </p>
        </div>

        <input
          type="file"
          multiple
          onChange={disabled ? undefined : onFilesChange}
          accept=".pdf,.docx,.txt"
          id="resume-upload"
          ref={fileInputRef}
          style={{ display: 'none' }}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default DropAreaLower;


